import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GiftCard } from '@kinomap-dev/ng-ui-lib';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment.local';

export type CurrencyType = 'eur' | 'usd';

@Injectable({ providedIn: 'root' })
export class GiftCardPlanService {

    constructor(private http: HttpClient) { }

    getGiftCards(currency: CurrencyType): Observable<GiftCard[]> {
        const url: string = environment.api.dashboard.giftCards;
        const params: HttpParams = new HttpParams()
            .append('currency', currency)
        return this.http
            .get<{ data: GiftCard[] }>(url, {
                params: params,
            })
            .pipe(
                map((res: { data: GiftCard[] }) => res.data as GiftCard[])
            );
    }
}